import { Box, Button } from '@chakra-ui/react';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { Alert } from '@ui/components/Alert';
import { normalizeError } from '@ui/util/errors';

export type QueryErrorProps = {
  title?: string;
  error?: Error | FetchBaseQueryError | SerializedError;
  onRetry?: () => void;
  isRetrying?: boolean;
};

export function QueryError({
  title,
  error,
  onRetry,
  isRetrying = false,
}: QueryErrorProps) {
  const e = normalizeError(error, 'Unknown error');

  return (
    <Box padding={6} width="100%">
      <Alert
        status="error"
        title={e?.title || title || 'Error loading!'}
        description={e?.description}
      >
        {onRetry && (
          <Button
            variant="ghost"
            onClick={onRetry}
            ml="auto"
            isLoading={isRetrying}
            loadingText="Retrying..."
          >
            Try again
          </Button>
        )}
      </Alert>
    </Box>
  );
}
